import { PartyPopper } from "lucide-react";

import { ModalCard } from "@/components/flowly/infra/ModalCard/ModalCard";
import { useLanguage } from "@/contexts/LanguageContext";
import { WhatsAppCommunityCard } from "./WhatsAppCommunityCard";
import { useFirstGenerationCommunityModal } from "./useFirstGenerationCommunityModal";

/**
 * One-time, app-level prompt shown after the user's first successful
 * generation, inviting them to the WhatsApp community. Rendered once near the
 * app root (inside GeneratedImagesProvider) alongside the other global modals.
 */
export function WhatsAppCommunityModal() {
  const { t } = useLanguage();
  const { isOpen, dismiss } = useFirstGenerationCommunityModal();

  return (
    <ModalCard isOpen={isOpen} onClose={dismiss} maxWidth="max-w-md">
      <div className="text-start">
        <div className="flex items-center gap-2 mb-1">
          <PartyPopper className="w-5 h-5 text-[#25D366]" />
          <h2 className="text-2xl font-black text-foreground">
            {t.community.modalTitle}
          </h2>
        </div>
        <WhatsAppCommunityCard
          source="first_generation"
          onJoin={dismiss}
          className="mt-3"
        />
        <button
          type="button"
          onClick={dismiss}
          className="mt-3 w-full text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          {t.community.modalDismiss}
        </button>
      </div>
    </ModalCard>
  );
}
